import clsx from 'clsx';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';
import Typography from '@dynatrace/strato-design-tokens/typography';

import { textStyleCSS } from '../../styles/textStyle.sty.js';

//#region Typings
/**
 * @public
 */
export interface TitleProps extends WithChildren, StylingProps, DataTestId {}
//#endregion Typings

/**
 * The title of the guided interaction overlays.
 * @public
 */
export const Title = (props: TitleProps) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;
  return (
    <div
      data-testid={dataTestId}
      className={clsx(
        textStyleCSS({ textStyle: 'base-emphasized' }),
        consumerClassName,
      )}
      style={{
        fontWeight: Typography.Text.Base.Emphasized.Weight,
        ...consumerStyle,
      }}
    >
      {children}
    </div>
  );
};

Title['displayName'] = 'GuidedInteraction.Title';
